import React, { useRef, useImperativeHandle } from 'react'

// styles
import './ProcessTimeTicketInput.css'

// components
import InputField from '../../InputField/InputField.component'
import SignatureCanvas from 'react-signature-canvas'
import ActionButton from '../../../buttons/ActionButton/ActionButton.component'

// mui
import { Grid, Container, Paper, FormControlLabel, Checkbox } from '@mui/material'

const CLASSIFICATION_OPTIONS = {
    J: 'Journeyman',
    F: 'Foreman',
    S: 'Superintendent',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8'
}

const ProcessTimeTicketInput = React.forwardRef(({ index, prefix, startTime, endTime, safetyAcknowledgment, crewMember, signatureImage, handleChange, onClearClicked, errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getSignature: () => { return assignmentSignature.current.getTrimmedCanvas().toDataURL("image/png")  },
        clear: () => { assignmentSignature.current.clear() }
    }))

    const assignmentSignature = useRef();

    return (<Paper variant='outlined' sx={{ padding: 4, marginBottom: 4, marginTop: 4}}>

        <div className='process-time-ticket-crew-member'>
            <div>{crewMember.firstName} {crewMember.lastName}</div>
            <div>{CLASSIFICATION_OPTIONS[crewMember.classification]}</div>
        </div>

        <Container disableGutters sx={{ marginBottom: 4}}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <InputField 
                        type='time'
                        id={`${prefix}.startTime`}
                        value={startTime}
                        placeholder='Start Time'
                        onChange={handleChange}
                        isValid={errors['startTime'] ? errors['startTime'] : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputField 
                        type='time'
                        id={`${prefix}.endTime`}
                        value={endTime}
                        placeholder='End Time'
                        onChange={handleChange}
                        isValid={errors['endTime']}
                    />
                </Grid>
            </Grid>
        </Container>

        <FormControlLabel
            control={<Checkbox 
                    checked={safetyAcknowledgment}
                    name={`${prefix}.safetyAcknowledgment`}
                    id={`${prefix}.safetyAcknowledgment`}
                    color="primary"
                    onChange={handleChange} 

                />}
            sx={errors['safetyAcknowledgment'] == false ? {color: "red"} : {color: "black"}}
            label="By signing this ticket, I acknowledge that I did not get hurt during my work shift this day."
            labelPlacement="end"
        />

        { safetyAcknowledgment && 
            <>
                <div className='process-time-tickets-signature-top'>
                    <span className='process-time-tickets-signature-title'>Please Sign Here</span>
                    <ActionButton color='error' label='Clear' size='small' onClick={() => onClearClicked(index)} />
                </div>
                <div className='ticket-signature-container'>

                    {  signatureImage ? <img className='ticket-signature-canvas' alt='signature' src={signatureImage} /> : <SignatureCanvas 
                        penColor='black'
                        canvasProps={{ className: "ticket-signature-canvas" }}
                        ref={assignmentSignature}
                        clearOnResize={false}
                        
                    /> }
                    
                    
                </div>
            </>
        }
        
        </Paper>)
})

export default ProcessTimeTicketInput